<template>
    <v-container class="pt-0">
        <HotelForm
            owner-creation-form
            :dialog-data.sync="dialogData"
            :initial-filled-data="hotelFormInitialFilledData"
            @finish="finish"
        />
    </v-container>
</template>

<script>
import HotelForm from "../../components/Hotel/HotelForm.vue";

export default {
    name: "OwnerCreation",
    components: {HotelForm},
    data: () => ({
        dialogData: {
            model: false,
            loading: false,
            dialogTitle: '',
            dialogMessage: '',
            dialogType: ''
        },
        INITIAL_FORM_HASH_SOURCE: 'initial-form',
        hotelFormInitialFilledData: null
    }),
    methods: {
        finish: function (data) {
            axios.post(`/api/hotel/store-by-owner?ownerSignature=${this.$route.params.externalId}`, data, { validateStatus: () => true })
                .then(res => {
                    if (res.data.success) {
                        this.dialogData.dialogTitle = 'Muito Bom';
                        this.dialogData.dialogMessage = 'Hotel Cadastrado com Sucesso!';
                        this.dialogData.dialogType = 'success';
                    } else {
                        this.dialogData.dialogTitle = 'Ops...';
                        this.dialogData.dialogMessage = 'Aconteceu algum problema...';
                        this.dialogData.dialogType = 'error';
                    }
                }).catch(() => {
                    this.dialogData.dialogTitle = 'Ops...';
                    this.dialogData.dialogMessage = 'Aconteceu algum problema...';
                    this.dialogData.dialogType = 'error';
                })
                .finally(() => {
                    this.dialogData.model = true;
                });
        },
        validateHashAccordingToSource () {
            this.getHashSource() === this.INITIAL_FORM_HASH_SOURCE
                ? this.validateInitialFormHash()
                : this.validateWhatsappLinkHash()
        },
        getHashSource () {
            const source = this.$route.query.source;
            return (source !== null && source !== '') ? source : null;
        },
        validateInitialFormHash () {
            axios.get(
                `/api/v1/owner-creation/validate-hash`,
                { params: { hash: this.$route.params.externalId } }
            ).then(response => {
                this.hotelFormInitialFilledData = response.data.data;
            }).catch(error => { this.redirectToUnavailableLinkPage(); });
        },
        validateWhatsappLinkHash () {
            axios.get(`/api/hotel/check-owner-signature/${this.$route.params.externalId}`)
                .catch(error => { this.redirectToUnavailableLinkPage(); });
        },
        redirectToUnavailableLinkPage () {
            this.$router.push({ name: 'unavailableLink' });
        }
    },
    beforeMount() {
        this.validateHashAccordingToSource();
    }
}
</script>

<style scoped>
</style>
